import type { ReactNode } from 'react';
import type { ReceiptStatus } from '../api/types';
import { messageOf } from '../lib/errors';
import { formatTL } from '../lib/money';

/** Durum rozetleri: renk + metin (PDF §04 "durumlar yalnız renkle anlatılmaz"). */
const RECEIPT_STATUS: Record<ReceiptStatus, [string, string]> = {
  ACTIVE: ['Aktif', 'ok'],
  CANCELLED: ['İptal', 'bad'],
  REFUNDED_PARTIAL: ['Kısmi iade', 'warn'],
  REFUNDED_FULL: ['İade', 'warn'],
};

export function ReceiptBadge({ status }: { status: ReceiptStatus }) {
  const [label, cls] = RECEIPT_STATUS[status];
  return <span className={`badge ${cls}`}>{label}</span>;
}

export function PeriodBadge({ status }: { status: 'OPEN' | 'CLOSED' }) {
  return status === 'CLOSED' ? <span className="badge red">Kapalı ay</span> : <span className="badge info">Açık</span>;
}

export function Money({ value, className = '' }: { value: string; className?: string }) {
  const neg = value.startsWith('-');
  return <span className={`num ${neg ? 'neg' : ''} ${className}`}>{formatTL(value)}</span>;
}

export function ErrorBox({ error }: { error: unknown }) {
  if (!error) return null;
  return <div className="alert bad" role="alert">{messageOf(error)}</div>;
}

export function Loading({ lines = 3 }: { lines?: number }) {
  return <div className="stack" aria-busy="true">{Array.from({ length: lines }, (_, i) => <div key={i} className="skeleton" />)}</div>;
}

export function Empty({ children }: { children: ReactNode }) {
  return <div className="empty">{children}</div>;
}

export function Field({ label, error, uncertain, children }: { label: string; error?: string; uncertain?: boolean; children: ReactNode }) {
  return (
    <label className={`field ${uncertain ? 'uncertain' : ''}`}>
      <span>{label}{uncertain && <span className="badge warn" style={{ marginLeft: 6 }}>Kontrol edin</span>}</span>
      {children}
      {error && <div className="err">{error}</div>}
    </label>
  );
}

export function Stat({ label, value }: { label: string; value: ReactNode }) {
  return <div className="card stat"><div className="label">{label}</div><div className="value">{value}</div></div>;
}
